"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        display: "flex",
        flex: 1,
        gap: "0.5rem",
        height: "100%",
        alignItems: "center",
        justifyContent: "flex-start",
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map